module.exports = __webpack_public_path__ + "static/media/home-blob.e5a19f6e.png";